import { Component } from "react";
import { FILE_DELIMITER, MAX_LENGTH } from "../../../../../../constants/external-constants";
import { InputFieldFloatingLabel as  InputField } from "../../../../../common/custom-form/select-filter.component";
import { SelectFieldFloatingLabel as Select } from "../../../../../common/custom-form/select-filter.component";
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import { connect } from "react-redux";
class OutputConfigForm extends Component {
    constructor(props) {
        super(props);
        this.state={

        }
    }

    toLocaleLanguage = (key, isCapitalize=true) => {
            const { locale } = this.props;
            if (locale === null || locale === '')
                return translation[translation['defaultLocaleLanguage']][key];
            
            return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
    }

    render() {
        const { outputConfigurationDropdownlist, outputConfigurationDetailsForm } = this.props;
        const { outputConfiguration } = outputConfigurationDetailsForm

        const disabledDelimiter = !outputConfiguration.fileFormatId || outputConfiguration.fileFormatId !== FILE_DELIMITER.xls.id;

        const defaultCurrency = outputConfigurationDropdownlist.Currency.find(
             (currency) => currency.Value === 'Default'
        );

        const defaultCurrencyId = defaultCurrency ? defaultCurrency.Key : null;

        return(
            <div className="details-field-container">
                 <InputField
                    className="form-control"
                    type="text"
                    label={`${this.toLocaleLanguage('configuration_num')}`}
                    value={outputConfiguration.configurationNumber}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.configurationNumber'
                    disabled={true}
                />
                <InputField
                    className="form-control required"
                    type="text"
                    label={`${this.toLocaleLanguage('configuration_name')}`}
                    value={outputConfiguration.configurationName}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.configurationName'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                    requiredField={true}
                />

                <InputField
                    className="form-control required"
                    type="text"
                    label={`${this.toLocaleLanguage('file_name')}`}
                    value={outputConfiguration.fileName}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.fileName'
                    maxLength={MAX_LENGTH.limit_255}
                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                />

                <Select
                    className="form-select required"
                    label={`${this.toLocaleLanguage('file_format')}`}
                    options={outputConfigurationDropdownlist.FileFormat}
                    value={outputConfiguration.fileFormatId}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={false}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.fileFormatId'
                    onChangeAction={(e, v) => this.props.setFileDelimiter(e, v)}
                />

                <InputField
                    className={`form-control ${!disabledDelimiter ? 'required' : ''}`}
                    type="text"
                    label={`${this.toLocaleLanguage('file_delimiter')}`}
                    value={outputConfiguration.fileDelimeter}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.fileDelimeter'
                    maxLength={MAX_LENGTH.limit_100}
                    disabled={disabledDelimiter}
                    placeholder={disabledDelimiter ? '' : `${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                />

                <Select
                    className="form-select required"
                    label={`${this.toLocaleLanguage('generate_json_file')}`}
                    options={outputConfigurationDropdownlist.GenerateJsonFile}
                    value={outputConfiguration.isGenerateJsonFile}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={false}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.isGenerateJsonFile'
                />

                <Select
                    className="form-select required"
                    label={`${this.toLocaleLanguage('currency_capital')}`}
                    options={outputConfigurationDropdownlist.Currency}
                    value={outputConfiguration.currencyId ?? defaultCurrencyId}
                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                    isError={false}
                    fieldProp='outputConfigurationDetailsForm.outputConfiguration.currencyId'
                />

            </div>
        )
    }
}

export default connect(
    state => {
        const { translation } = state;
        return {
            ...translation
        }
    }
)(OutputConfigForm);